(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vg-bambu-printer-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var button = event.target.closest('.vg-bpg__video-play');
    if (!button) return;

    var src = button.getAttribute('data-embed');
    if (!src) return;

    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', src);
    iframe.setAttribute('title', button.getAttribute('data-title') || '');
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    );
    iframe.setAttribute('allowfullscreen', '');

    button.replaceWith(iframe);
  });

  document.addEventListener(
    'error',
    function (event) {
      var image = event.target;
      if (!image.classList || !image.classList.contains('vg-bpg__video-poster')) return;

      var fallback = image.getAttribute('data-fallback');
      if (!fallback || image.src === fallback) return;

      image.removeAttribute('data-fallback');
      image.src = fallback;
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vg-bf-jump-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vg-bf-jump-nav')) {
    class VgBfJumpNav extends HTMLElement {
      connectedCallback() {
        this.links = Array.from(this.querySelectorAll('a[href^="#"]')).filter((link) => link.hash.length > 1);
        this.targets = this.links.map((link) => document.getElementById(decodeURIComponent(link.hash.slice(1)))).filter(Boolean);

        if (!this.targets.length || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.setActive(entry.target.id);
          });
        }, { rootMargin: '-30% 0px -60% 0px' });

        this.targets.forEach((target) => this.observer.observe(target));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      setActive(id) {
        this.links.forEach((link) => {
          const active = link.hash === '#' + id;
          link.setAttribute('aria-current', active ? 'true' : 'false');
          if (active) link.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
      }
    }

    customElements.define('vg-bf-jump-nav', VgBfJumpNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vg-countdown-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vg-countdown-hero')) {
    class VgCountdownHero extends HTMLElement {
      connectedCallback() {
        this.target = Date.parse(this.dataset.target || '');
        this.running = this.querySelector('.vg-countdown-hero__running');
        this.ended = this.querySelector('.vg-countdown-hero__ended');
        this.numbers = {};
        this.querySelectorAll('[data-unit]').forEach((el) => {
          this.numbers[el.dataset.unit] = el;
        });

        if (Number.isNaN(this.target)) return;

        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const remaining = this.target - Date.now();

        if (remaining <= 0) {
          clearInterval(this.timer);
          this.render(0);
          this.expire();
          return;
        }

        this.render(remaining);
      }

      render(ms) {
        const total = Math.floor(ms / 1000);
        const values = {
          days: Math.floor(total / 86400),
          hours: Math.floor((total % 86400) / 3600),
          minutes: Math.floor((total % 3600) / 60),
          seconds: total % 60,
        };

        Object.keys(values).forEach((unit) => {
          const el = this.numbers[unit];
          const text = String(values[unit]).padStart(2, '0');
          if (el && el.textContent !== text) el.textContent = text;
        });
      }

      expire() {
        const behavior = this.dataset.expiredBehavior;

        if (behavior === 'hide') {
          const wrap = this.closest('.vg-countdown-hero__panel-wrap');
          if (wrap && !window.Shopify?.designMode) wrap.hidden = true;
        } else if (behavior === 'message' && this.ended) {
          this.running.hidden = true;
          this.ended.hidden = false;
        }
      }
    }

    customElements.define('vg-countdown-hero', VgCountdownHero);
  }

  } catch(e) { console.error(e); }
})();
})();
